module.exports = __webpack_public_path__ + "3fb9be1d5b92d573b26c896cbe84c864.png";